import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import PopupForm from './PopupForm';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupType] = useState('register_now');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleHomeAnchorClick = (e, id) => {
    e.preventDefault();
    setIsMenuOpen(false);

    const scrollToSection = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.location.href = `/#${id}`;
      }
    };

    if (window.location.pathname === '/') {
      scrollToSection();
    } else {
      navigate('/');
      setTimeout(scrollToSection, 200);
    }
  };

  return (
    <header className="site-header" role="banner">
      <div className="wrap nav">
        <div className="logo-container">
          <Link to="/" className="logo-link" aria-label="Lead With Tech home">
            <img src="/images/lwt.png" alt="Lead With Tech" height={50} width={120} />
          </Link>
        </div>

        <button
          className="mobile-menu-btn"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          aria-controls="main-nav-links"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>

        <nav id="main-nav-links" className={`main-nav ${isMenuOpen ? 'active' : ''}`} role="navigation" aria-label="Main navigation">
          <ul className="nav-links">
            <li><a href="/#flagship" onClick={(e) => handleHomeAnchorClick(e, 'flagship')}>Flagship Programs</a></li>
            <li><a href="/#certifications" onClick={(e) => handleHomeAnchorClick(e, 'certifications')}>Certification Programs</a></li>
            <li><a href="/#career" onClick={(e) => handleHomeAnchorClick(e, 'career')}>Career Authoring</a></li>
            <li><Link to="/careerplans">Memberships</Link></li>
            <li><Link to="/subscriptions">Subscriptions</Link></li>
            <li><a href="/#events" onClick={(e) => handleHomeAnchorClick(e, 'events')}>Events</a></li>
            <li><a href="/#jobs" onClick={(e) => handleHomeAnchorClick(e, 'jobs')}>Jobs</a></li>
            <li><a href="/#about" onClick={(e) => handleHomeAnchorClick(e, 'about')}>About</a></li>
          </ul>
        </nav>

        <div className="nav-cta">
          <a className="btn btn-red btn-sm" href="/#flagship" onClick={(e) => handleHomeAnchorClick(e, 'flagship')}>
            Get Started
          </a>
        </div>
      </div>

      <PopupForm 
        isOpen={isPopupOpen} 
        onClose={() => setIsPopupOpen(false)} 
        formType={popupType}
      />
    </header>
  );
}

export default Header;